<template>
  <div v-show="badgeCount > 0" class="badge-count">
    <span v-if="countable">{{ badgeCount | displayCount }}</span>
  </div>
</template>

<script>
export default {
  filters: {
    displayCount(num) {
      if (num > 99) {
        return '99+';
      }
      return num;
    },
  },
  props: {
    badgeCount: {
      type: Number,
      default: 0,
    },
    countable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="sass" scoped>

.badge-count
  z-index: 1
  right: 6px
  top: 6px
  position: absolute
  font-size: 16px
  font-weight: bold
  font-family: $regular-font-family
  padding: 0
  min-width: 15px
  max-width: 15px
  height: 15px
  line-height: 28px
  text-align: center
  border-radius: 15px
  background: $palette-red-bittersweet
  color: $palette-white
  white-space: nowrap
  animation: animationFrames 2s
  animation-iteration-count: 3
  -webkit-user-select: none
  user-select: none
  span
    padding: 0 3px

=keyframes($name)
  @-webkit-keyframes #{$name}
    @content
  @-moz-keyframes #{$name}
    @content
  @-ms-keyframes #{$name}
    @content
  @keyframes #{$name}
    @content

+keyframes(animationFrames)
  0%
    transform: translate(0px, 0px)
  15%
    transform: translate(0px, -10px)
  30%
    transform: translate(0px, 0px)
  45%
    transform: translate(0px, -3px)
  60%
    transform: translate(0px, 0px)
  75%
    transform: translate(0px, -2px)
  100%
    transform: translate(0px, 0px)
</style>
